import { render, staticRenderFns } from "./EnterTestResultsButton.vue?vue&type=template&id=326d840e&"
import script from "./EnterTestResultsButton.vue?vue&type=script&lang=js&"
export * from "./EnterTestResultsButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports